import React from 'react'
import SurgicalSchedulingContextWrapper from 'presentation/hospital/layouts/Home/SchedulingSector/context'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import HospitalScheduledSurgeriesLayout from 'presentation/hospital/layouts/Home/SchedulingSector/ScheduledSurgeries'

export default function HospitalScheduledSurgeries() {
  return (
    <SurgicalSchedulingContextWrapper>
      <ContainerNew>
        <HospitalScheduledSurgeriesLayout />
      </ContainerNew>
    </SurgicalSchedulingContextWrapper>
  )
}
